angular.module('unergie.main')
.directive('deleteconfirm', () =>
    ({
        restrict: 'E',
        templateUrl: '/directives/deleteconfirm/deleteconfirm.html',
        scope: {
            delete: '&',
        },
        link($scope) {
            $scope.close = () => ($scope.opened = false)
        },
    }),
)
